// import Vue from 'vue'
import axios from "axios"
export default {
  MessageNum(context, payload) { //这里的context和我们使用的$store拥有相同的对象和方法
    context.commit('SAVE_MY_NUM', payload);
    //你还可以在这里触发其他的mutations方法
  },
  Homebtn(context, payload) {
    context.commit('SAVE_MY_HOMEBTN', payload);
  },
  HomebtnHr(context, payload) {
    context.commit('SAVE_MY_HOMEBTNHR', payload)
  },
  Modelmes(context, payload) {
    context.commit('SAVE_MY_MODELMES', payload);
  },
  axios_response(context, payload) {
    context.commit('SAVE_MY_AXIOS_RESPONSE', payload);
  },
  Mreturn(context, payload) {
    context.commit('SAVE_MY_MRETURN', payload);
  },
  initConfig({ commit }) {
    Vue.prototype.$api.plat.getbasicAll(res => {
      var datas = res.data
      commit("LOAD_CONFIG_DATA", datas);
    })
  },
  chatData(context, payload) {
    context.commit('SAVE_MY_CHATDATA', payload);
  },
  subCondition(context, payload) {
    context.commit('SAVE_MY_SUBCONDITION', payload);
  },
  assistantUnReads(context, payload) {
    context.commit('SAVE_MY_ASSISTANTS', payload);
  },
  assistantChange(context, payload) {
    context.commit('SAVE_MY_ASSISTANTCHANGE', payload);
  },
  editActive(context, payload) {
    context.commit('SAVE_MY_EDITACTIVE', payload);
  },
  //头
  homePageHeadInfo(context, payload) {
    context.commit('SAVE_MY_HPH', payload);
  },
  //介绍
  descriptionInfo(context, payload) {
    context.commit('SAVE_MY_DSI', payload);
  },

  //发展历程
  developmentInfo(context, payload) {
    context.commit('SAVE_MY_DVI', payload);
  },

  //福利
  welfareOthersInfo(context, payload) {
    context.commit('SAVE_MY_WOI', payload);
  },
  //地址
  locationInfo(context, payload) {
    context.commit('SAVE_MY_ELI', payload);
  },

  //领军团队
  leadTeamInfo(context, payload) {
    context.commit('SAVE_MY_LTI', payload);
  },
  //公司环境
  environmentPhotoPathInfo(context, payload) {
    context.commit("SAVE_MY_EPPI", payload);
  },
  certificationInfo(context, payload) {
    context.commit("SAVE_MY_CFI", payload);
  },

  saveSearchPositionHistory(context, payload) {
    try {
      // let tempObj = JSON.parse(localStorage.positionSearchH_1);
      let tempObj = localStorage.positionSearchH_1;
      let localSearchHistory = Object.values(tempObj);

      if (localSearchHistory && localSearchHistory.length > 0) {
        // let jsonHistory = JSON.parse(localSearchHistory);
        store.commit("UPDATE_USER_SEARCHPOSITIONHISTORY", localSearchHistory);
      } else {
        store.commit("UPDATE_USER_SEARCHPOSITIONHISTORY", []);
      }
    } catch (err) {
    }

  },
  async loadGlobalConfig({ commit, state }) {
    if (state.configData) return;
    return await axios.get(`https://cdn.beilie.cloud/tempdb/global_config_data.json`).then((res) => {
      return res.data;
    }).then(cfg => {

      commit("LOAD_CONFIG_DATA", cfg)
    })
  },
}
